export default "__VITE_ASSET__c3b5ab1d__"